<template>
  <div class="news">
    <div class="addbox">
      <el-button class="add-btn" icon="el-icon-plus" @click="add"
        >添加背景</el-button
      >
    </div>
    <div class="top">
      <!-- <div class="querybox">
        <div>
          <p>背景资源标题：</p>
          <el-input
            v-model="queryParams.title"
            placeholder="请输入背景资源标题"
            clearable
          ></el-input>
        </div>
        <div>
          <p>发布时间：</p>
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>-->
      <div class="handlebox">
        <div class="btnbox">
          <el-popconfirm
            icon="el-icon-info"
            icon-color="red"
            title="确认删除选中的背景资源吗？"
            popper-class="customerdel-popover"
            @confirm="deleteFn()"
          >
            <el-button
              slot="reference"
              icon="el-icon-delete"
              class="add-btn"
              style="margin-right: 10px"
              >删除</el-button
            >
          </el-popconfirm>
          <!-- <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          > -->
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"> </el-table-column>
        <el-table-column prop="img" label="背景图">
          <template slot-scope="{ row }">
            <el-image :src="row.img" :preview-src-list="[row.img]"> </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="背景名称"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="createdTime" label="发布时间"> </el-table-column>
        <el-table-column prop="img" label="地址">
          <template slot-scope="{ row }">
            <el-button
              class="textBlue-btn"
              slot="reference"
              @click="copyUrl(row.img)"
              >复制地址</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="status_dictText" label="状态">
          <template slot-scope="{ row }">
            <el-button :class="row.status === 0 ? 'success-btn' : 'fail-btn'">{{
              row.status === 0 ? "正常" : "禁用"
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-popconfirm
              title="是否启用该背景资源？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 0)"
              v-if="Number(scope.row.status) === 1"
            >
              <el-button class="textOrange-btn" slot="reference"
                >启用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否禁用该背景资源？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 1)"
              v-if="Number(scope.row.status) === 0"
            >
              <el-button class="textOrange-btn" slot="reference"
                >禁用</el-button
              >
            </el-popconfirm>
            <el-button class="textOrange-btn" @click="goEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
import { getNewsList, editNewsStatus, deleteNews } from "@/api/home";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        title: "",
      },
      tableData: [
        {
          img: "https://oss.laihi.cc/news/1dda021ea30247ab8897d409b7a1e6a8.jpg",
          createdTime: "2024-12-14 11:00:18",
          id: "1867766533791416320",
          status_dictText: "优先推荐显示",
          title: "背景图",
          status: 1,
        },
      ],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      selectList: [],
    };
  },
  created() {
    // this.init();
  },
  mounted() {},
  methods: {
    //获取背景资源列表
    async init() {
      const res = await getNewsList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.title = "";
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.pageNum = 1;
      this.value = "";
      this.init();
    },
    timeChange(event) {
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    // 添加
    add() {
      this.$router.push({
        path: "/addNews",
        query: {
          type: "add",
        },
      });
    },
    // 编辑
    goEdit(item) {
      // localStorage.setItem("newsInfo", JSON.stringify(item));
      this.$router.push({
        path: "/addNews",
        query: {
          type: "edit",
          id: item.id,
        },
      });
    },
    //修改背景资源 状态
    async cancelOrder(item, status) {
      const params = {
        status,
        id: item.id,
      };
      await editNewsStatus(params);
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 选择
    handleSelectionChange(val) {
      this.selectList = val.map((el) => {
        return el.id;
      });
    },
    // 删除
    async deleteFn() {
      if (this.selectList.length === 0) {
        this.$message.error("请先选择要删除的背景资源");
        return;
      }
      await deleteNews(this.selectList);
      this.$message.success("删除成功");
      this.init();
    },
    // 复制
    async copyUrl(url) {
      const textToCopy = url;
      await navigator.clipboard.writeText(textToCopy);
      this.$message.success("复制成功");
    },
  },
};
</script>
<style lang="scss" scoped>
.news {
  position: relative;

  .addbox {
    position: absolute;
    top: -88px;
    right: 0;
  }

  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;

    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;

        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }

        .el-input,
        .el-range-editor {
          width: 216px;
        }

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }

        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }

    .handlebox {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 0;
      flex: 1;
    }
  }

  .content {
    .logo {
      display: flex;
      justify-content: center;

      img {
        width: 87px;
        height: 56px;
        border-radius: 4px;
      }
    }

    .textOrange-btn {
      margin: 0 10px;
    }
  }

  ::v-deep .is-checked {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }

  ::v-deep .is-indeterminate {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
}
</style>
